<div class="main-content">
  <div class="container-fluid">

    <div class="admin-page-header" *ngIf="exportAuthorized()">
      <div class="header-actions">
        <button (click)="exportCSV()" class="btn btn-sm btn-action">
          <i class="fa fa-download"></i> Mentoring Surveys CSV
        </button>
        <button (click)="exportPssCSV()" class="btn btn-sm btn-action">
          <i class="fa fa-download"></i> PSS Surveys CSV
        </button>
      </div>
    </div>

    <div class="services-table-wrap">
      <loader *ngIf="loading"></loader>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th *ngFor="let cell of headerRow" (click)="sortCell(cell)" class="sortable">
                {{ cell }}
                <i class="fa fa-sort-asc"  *ngIf="sortSelected == cell && sortDirection == 'ASC'"></i>
                <i class="fa fa-sort-desc" *ngIf="sortSelected == cell && sortDirection == 'DESC'"></i>
                <i class="fa fa-sort sort-neutral" *ngIf="sortSelected != cell"></i>
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of associations">
              <td>{{ row['ID'] }}</td>
              <td><a class="row-link" (click)="openNewTab('/#/project/'+row['project_id'])">{{ row['Project'] }}</a></td>
              <td><a class="row-link" (click)="openNewTab('/#/epe/'+row['epe_id'])">{{ row['EPE'] }}</a></td>
              <td class="d-none d-md-table-cell">{{ row['Status'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Project Survey 1'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Project Survey 2'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Project Survey 3'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Project Survey 4'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Final Epe Survey'] }}</td>
              <td class="d-none d-md-table-cell">{{ row['Final Project Survey'] }}</td>
              <td>
                <button (click)="goToDashboard(row['project_id'], row['epe_id'])"
                        class="btn btn-sm btn-primary">
                  Go to surveys <i class="fa fa-arrow-right"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
  